import { HttpClient } from "./httpClient"
import { SetSaveEvent } from "./formEvents"
import { showToast } from "@commonComponents/showToast"

export const saveMassUpdateData = (eventType, params) => {
    const request = SetSaveEvent(eventType, {
        shipmentId: window.shipmentId,
        ...params
    })
    return HttpClient.post(request)
        .then((res) => res)
        .catch((error) => {
            showToast('Something went wrong,cannot save the value!')
            console.error(error)
        })
}